import { render } from "./SortedProjects.vue?vue&type=template&id=46ad5eec"
import script from "./SortedProjects.vue?vue&type=script&lang=js"
export * from "./SortedProjects.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__